import * as THREE from "three";
import data_view_pb from "@/proto/data_view_pb.js";

/**
 * VirtualObstacle.VirtualType 获取枚举name
 * @param {*} value 
 * @returns 
 */
export function getVirtualTypeName(value) {
    for (let key in data_view_pb.VirtualObstacle.VirtualType) {
        if (data_view_pb.VirtualObstacle.VirtualType[key] == value) {
            return key;
        }
    }
    return null;
}


/**
 * 障碍物类型枚举
 * @param {*} value 
 * @returns 
 */
export function getObstacleType() {

    let typeList = [];

    typeList.push(buildObstacleSetting(0, 9, '未知物', 'MISC', 'Misc', 'LineBasic', 0x7fb80e, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(1, 1, '小汽车', 'CAR', 'Car', 'LineDashed', 0x6f60aa, 0.1, 'car.glb', true, 'glb', { x: 0, y: 0, z: Math.PI, axis: "z" }, { x: 0.8, y: 0.8, z: 0.8 }))
    typeList.push(buildObstacleSetting(20, 1, '警车', 'POLICE_VEHICLE', 'POLICE_VEHICLE', 'LineDashed', 0x6f60aa, 0.1, 'car.glb', true, 'glb', { x: 0, y: 0, z: Math.PI, axis: "z" }, { x: 0.8, y: 0.8, z: 0.8 }))




    typeList.push(buildObstacleSetting(2, 1, '卡车', 'TRUCK', 'Truc', 'LineDashed', 0x63434f, 0.3, 'truck', true, 'obj', { x: Math.PI / 2, y: Math.PI / 2, z: 0, axis: "y" }, { x: 0.03, y: 0.02, z: 0.04 }))
    typeList.push(buildObstacleSetting(21, 1, '拖车', 'TRAILER', 'TRAILER', 'LineDashed', 0x63434f, 0.3, 'truck', true, 'obj', { x: Math.PI / 2, y: Math.PI / 2, z: 0, axis: "y" }, { x: 0.03, y: 0.02, z: 0.04 }))
    typeList.push(buildObstacleSetting(22, 1, '洒水车', 'STREET_SPRINKLER', 'StrSpr', 'LineDashed', 0x63434f, 0.3, 'truck', true, 'obj', { x: Math.PI / 2, y: Math.PI / 2, z: 0, axis: "y" }, { x: 0.03, y: 0.02, z: 0.04 }))
    typeList.push(buildObstacleSetting(23, 1, '工程车', 'CONSTRUCTION_VEHICLE', 'ConsVeh', 'LineDashed', 0x63434f, 0.3, 'truck', true, 'obj', { x: Math.PI / 2, y: Math.PI / 2, z: 0, axis: "y" }, { x: 0.03, y: 0.02, z: 0.04 }))
    typeList.push(buildObstacleSetting(24, 1, '罐车', 'TRANKER', 'TRANKER', 'LineDashed', 0x63434f, 0.3, 'truck', true, 'obj', { x: Math.PI / 2, y: Math.PI / 2, z: 0, axis: "y" }, { x: 0.03, y: 0.02, z: 0.04 }))
    typeList.push(buildObstacleSetting(25, 1, '吊车', 'CRANE', 'CRANE', 'LineDashed', 0x63434f, 0.3, 'truck', true, 'obj', { x: Math.PI / 2, y: Math.PI / 2, z: 0, axis: "y" }, { x: 0.03, y: 0.02, z: 0.04 }))


    typeList.push(buildObstacleSetting(3, 1, '公交车', 'BUS', 'Bus', 'LineDashed', 0x543044, 0.3, 'bus.glb', true, 'glb', { x: 0, y: 0, z: Math.PI }, { x: 0.6, y: 0.6, z: 0.6 }))
    typeList.push(buildObstacleSetting(4, 1, '行人', 'PEDESTRIAN', 'Pede', 'LineBasic', 0x007947, 0.3, 'pedestrian.glb', true, 'glb', { x: 0, y: 0, z: Math.PI / 2, axis: "z" }, { x: 1, y: 1, z: 0.8 }))
    typeList.push(buildObstacleSetting(50, 1, '警察', 'POLICE_OFFICIER', 'Pol', 'LineBasic', 0x007947, 0.3, 'pedestrian.glb', true, 'glb', { x: 0, y: 0, z: Math.PI / 2, axis: "z" }, { x: 1, y: 1, z: 0.8 }))
    typeList.push(buildObstacleSetting(51, 1, '安全员', 'SECURITY_PERSONNEL', 'SP', 'LineBasic', 0x007947, 0.3, 'pedestrian.glb', true, 'glb', { x: 0, y: 0, z: Math.PI / 2, axis: "z" }, { x: 1, y: 1, z: 0.8 }))
    typeList.push(buildObstacleSetting(52, 1, '小孩', 'CHILD', 'CHILD', 'LineBasic', 0x007947, 0.3, 'pedestrian.glb', true, 'glb', { x: 0, y: 0, z: Math.PI / 2, axis: "z" }, { x: 1, y: 1, z: 0.8 }))


    typeList.push(buildObstacleSetting(5, 1, '自行车，摩托车', 'BICYCLE', 'Bicy', 'LineDashed', 0xa3cf62, 0.3, 'zxc.glb', true, 'glb', { x: Math.PI / 2, y: Math.PI / 2, z: 0, axis: "y" }, { x: 0.01, y: 0.01, z: 0.01 }))
    typeList.push(buildObstacleSetting(6, 1, '三轮车', 'TRICYCLE', 'Tric', 'LineBasic', 0xe0861a, 0.3, 'bicycle2', true, 'obj', { x: Math.PI / 2, y: Math.PI / 2, z: 0, axis: "y" }, { x: 0.0002, y: 0.0002, z: 0.0002 }))
    typeList.push(buildObstacleSetting(7, 1, '快递车、老头乐', 'SPECIAL_SMALL_VEHICLE', 'SSV', 'LineBasic', 0xe0861a, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(26, 1, '叉车', 'FORKLIFT', 'Fork', 'LineBasic', 0xe0861a, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(27, 1, '无人快递车', 'UNMANNED_DELIVERY_VEHICLE', 'UDV', 'LineBasic', 0xe0861a, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(29, 1, '有人快递车', 'DELIVERY_VEHICLE', 'DV', 'LineBasic', 0xe0861a, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(28, 1, '老头乐', 'ELDERLY_MOBILITY_SCOOTER', 'EMS', 'LineBasic', 0xe0861a, 0.3, '', false, ''))




    typeList.push(buildObstacleSetting(8, 9, '类型未知的bev结果', 'UNKNOWN_OBSTACLE', 'UObs', 'LineBasic', 0x7fb80e, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(100, 9, '静态元素，比如花坛', 'MAP_POINT_CLUSTER', 'MPC', 'LineBasic', 0x70a19f, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(101, 3.1, '锥桶', 'TRAFFIC_CONE', 'TC', 'LineBasic', 0x2585a6, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(102, 3.1, '点云低矮障碍物', 'LOW_PROFILE_OBSTACLE', 'LPO', 'LineBasic', 0x508a88, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(103, 1, '停放的自行车', 'UNMANNED_BICYCLE', 'uBic', 'LineBasic', 0x508a88, 0.3, 'bicycle', false, 'obj', { x: Math.PI / 2, y: Math.PI / 2, z: 0, axis: 'y' }, { x: 0.003, y: 0.003, z: 0.005 }))
    typeList.push(buildObstacleSetting(104, 4, '植被', 'VEGETATION', 'Vege', 'LineBasic', 0x508a88, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(105, 4, '道路', 'ROAD', 'Road', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(106, 4, '马路牙子', 'CURB', 'Curb', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(107, 4, '建筑物', 'BUILDING', 'Buil', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(108, 4, '墙壁', 'WALL', 'Wall', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(109, 4, '栅栏', 'FENCE', 'fenc', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(110, 4, '杆状物', 'POLE', 'Pole', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(111, 4, '交通灯', 'TRAFFIC_LIGHT', 'tLig', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(112, 4, '交通标志', 'TRAFFIC_SIGN', 'tSign', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(113, 3.1, '图像低矮障碍物', 'SEMANTIC_LOW_OBSTACLE', 'SLO', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(114, 3.1, '井盖', 'MANHOLE_COVER', 'MCov', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(115, 9, '需绕行区域', 'UNNAVIGABLE_AREA', 'UArea', 'LineBasic', 0x007947, 0.3, '', false, ''))

    typeList.push(buildObstacleSetting(116, 9, '未知静态障碍物', 'UNKNOWN_NONMOVABLE', 'UNmo', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(117, 4, '抬杆', 'LIFTING_LEVER', 'LLev', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(118, 4, '坑洞', 'HOLE', 'Hole', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(119, 3.1, '漂浮物', 'FLOATING_OBSTACLE', 'FObs', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(120, 4, '树干', 'Trunk', 'Trunk', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(121, 3.1, '交通安全桶', 'TRAFFIC_BARREL', 'TFBarr', 'LineBasic', 0x007947, 0.3, '', false, ''))



    typeList.push(buildObstacleSetting(150, 3.1, '树枝', 'BRANCH', 'Bran', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(151, 3.1, '土堆', 'MOUND', 'Mound', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(152, 3.1, '纸张', 'PAPER', 'Paper', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(153, 3.1, '石头', 'STONE', 'Stone', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(154, 3.2, '箱子', 'SmallBox', 'SBox', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(155, 3.2, '塑料袋', 'PLASTIC_BAG', 'PBag', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(156, 3.2, '动物', 'ANIMAL', 'Anim', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(157, 3.2, '三角警示牌', 'HAZARD_TRIANGLE', 'HTria', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(158, 3.2, '杆状物', 'SHAFT', 'Shaft', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(159, 3.2, '桶状物', 'BARREL', 'Barr', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(160, 3.2, '翻倒自行车', 'OVERTURNED_BICYCLE', 'oBic', 'LineBasic', 0x007947, 0.3, '', false, ''))


    typeList.push(buildObstacleSetting(161, 3.2, '座椅', 'LOW_SEAT', 'Seat', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(162, 3.2, '地桩', 'LOW_STAKE', 'Stake', 'LineBasic', 0x007947, 0.3, '', false, ''))


    typeList.push(buildObstacleSetting(179, 3.2, '其他低矮障碍物', 'LOWOTHERS', 'LOths', 'LineBasic', 0x007947, 0.3, '', false, ''))

    typeList.push(buildObstacleSetting(181, 4, '推拉门', 'RETRACTABLE_GATE', 'RetrG', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(182, 4, '卷帘门', 'ROLLING_SHUTTER', 'RollG', 'LineBasic', 0x007947, 0.3, '', false, ''))

    typeList.push(buildObstacleSetting(199, 9, '背景', 'BACKGROUND', 'Back', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(200, 9, '虚拟障碍物', 'ARTIFICIAL_OBJECT', 'ArtOb', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(201, 9, '盲区虚拟障碍物', 'BLIND_SPOT_OBSTACLE', 'BSO', 'LineBasic', 0x007947, 0.3, '', false, ''))
    typeList.push(buildObstacleSetting(255, 9, '其他', 'OTHER', 'Other', 'LineBasic', 0x007947, 0.3, '', false, ''))
    return typeList
}

let map_GroupOrderZ = null;
/**
 * 获取图层的order z 
 * @param {*} key 
 * @returns 
 */
export function getGroupOrderZ(key) {
    let map = initGroupOrderZ();
    if(map.has(key)){
        return map.get(key);
    }else{
        return new GroupOrderObject('other', 'other', 0.005, 100)
    }
}
export function initGroupOrderZ() {
    if (map_GroupOrderZ) {
        return map_GroupOrderZ;
    }
    map_GroupOrderZ = new Map()
    map_GroupOrderZ.set('pnc_planning', new GroupOrderObject('pnc_planning', '主routing', 0.005, 100))
    map_GroupOrderZ.set('pnc_routing', new GroupOrderObject('pnc_routing', '主routing', 0.007, 100))

    map_GroupOrderZ.set('pnc_routing_main', new GroupOrderObject('pnc_routing_main', '主routing', 0.006, 100))
    map_GroupOrderZ.set('pnc_routing_sub', new GroupOrderObject('pnc_routing_sub', '主routing', 0.006, 100))
    map_GroupOrderZ.set('pnc_routing_stop', new GroupOrderObject('pnc_routing_stop', '主routing', 0.007, 100))
    return map_GroupOrderZ
}
class GroupOrderObject {
    constructor(key, title, z, order) {
        this.z = z;
        this.title = title;
        this.key = key;
        this.order = order
    }
}

/**
 * 
 * @param {*} key proto 的type value
 * @param {*} teamKey 显示配置的分组key
 * @param {*} cName type的英文名
 * @param {*} eName type的中文名
 * @param {*} label threejs中的type缩写
 * @param {*} mType 材质的类型
 * @param {*} mColor 材质的颜色
 * @param {*} opacity 材质的透明度
 * @param {*} path 模型的路径
 * @param {*} isModel 是否模型
 * @param {*} modelType 模型类型
 * @param {*} rotation 模型的旋转角度
 * @param {*} scale 模型的大小比例
 * @returns 
 */
function buildObstacleSetting(key, teamKey, cName, eName, label, mType, mColor, opacity = 0.3, path, isModel, modelType, rotation, scale) {
    return {
        key, cName, eName, label, teamKey,
        viewSetting: {
            mateialSetting: {
                type: mType,
                setting: {
                    color: mColor,
                    side: THREE.DoubleSide,
                    opacity
                }
            },
            modelSetting: {
                description: eName,
                path,
                isModel,
                modelType,
                rotation,
                scale
            }
        }
    }
}